module.exports = __webpack_public_path__ + "static/media/cordstrapfront.c2cedfc9.png";